import React from 'react';
import emptyStateLogo from "../../assets/empty-state.svg";
import './EmptyState.scss';

export interface IEmptyStateProps {
    message: string;
}

const EmptyState: React.FC<IEmptyStateProps> = ({message}) => (
    <div className="empty-state">
        <img src={emptyStateLogo} alt="empty-state"/>
        <span>{message}</span>
    </div>
);

export default EmptyState;
